import { useContext, useEffect } from 'react';

import axios from 'axios';

import { AppSettingsContext } from '../app-settings';

export const BackendUrlInterceptor = () => {
  const appSettings = useContext(AppSettingsContext);

  useEffect(() => {
    const urlInterceptorId = axios.interceptors.request.use((config) => {
      const sharedApiPrefix = '/web-api/';
      const newApiPrefix = `${sharedApiPrefix}b2c/`;

      const fullUrl = config.url ?? '';

      const newApiUpdatedUrl = `${removeApiIfEndWithIt(appSettings.newApiUrl)}/${fullUrl.replace(newApiPrefix, '')}`;

      const sharedApiUpdatedUrl = `${removeApiIfEndWithIt(appSettings.sharedApiUrl)}/${fullUrl.replace(
        sharedApiPrefix,
        ''
      )}`;

      const updatedFullUrl = fullUrl.startsWith(newApiPrefix) ? newApiUpdatedUrl : sharedApiUpdatedUrl;

      config.url = updatedFullUrl;

      return config;
    });

    return () => {
      axios.interceptors.request.eject(urlInterceptorId);
    };

  }, [appSettings.newApiUrl, appSettings.sharedApiUrl]);

  return null;

  function removeApiIfEndWithIt(url:string):string{
    if(url.endsWith("/api/"))
      return url.replace("/api/","");

    return url;
  }
};
